const PINNED_CONTAINER_CLASS = "k-grid-pinned-container";
const PINNED_WRAP_CLASS = "k-grid-pinned-wrap";
const PINNED_SOURCE_CLASS = "k-pinned-source";
const kendo = window.kendo;
const $ = kendo.jQuery;

function createPinnedContainer(position, sizeClass) {
    const isBottom = position === "bottom";

    const container = document.createElement("div");
    container.className = PINNED_CONTAINER_CLASS + (isBottom ? " k-pos-bottom" : "");

    const wrap = document.createElement("div");
    wrap.className = PINNED_WRAP_CLASS;

    const table = document.createElement("table");
    table.className = "k-grid-table k-table" + (sizeClass ? " " + sizeClass : "");
    table.setAttribute("aria-label", isBottom ? "Pinned bottom rows" : "Pinned top rows");

    const tbody = document.createElement("tbody");
    tbody.className = "k-table-tbody";
    table.appendChild(tbody);

    wrap.appendChild(table);
    container.appendChild(wrap);

    return { container, wrap, table, tbody };
}

function syncPinnedColgroups(sourceTable, topTable, bottomTable) {
    if (!sourceTable) {
        return;
    }

    const syncColgroupOnly = (target, src) => {
        const existing = target.querySelector(":scope > colgroup");
        if (existing) {
            existing.remove();
        }
        const srcColgroup = src.querySelector(":scope > colgroup");
        if (srcColgroup) {
            target.prepend(srcColgroup.cloneNode(true));
        }
    };

    if (topTable) {
        syncColgroupOnly(topTable, sourceTable);
    }
    if (bottomTable) {
        syncColgroupOnly(bottomTable, sourceTable);
    }
}

function syncPinnedScroll(source, content, topWrap, bottomWrap) {
    const scrollLeft = source.scrollLeft;

    if (content && content !== source && content.scrollLeft !== scrollLeft) {
        content.scrollLeft = scrollLeft;
    }
    if (topWrap && topWrap !== source && topWrap.scrollLeft !== scrollLeft) {
        topWrap.scrollLeft = scrollLeft;
    }
    if (bottomWrap && bottomWrap !== source && bottomWrap.scrollLeft !== scrollLeft) {
        bottomWrap.scrollLeft = scrollLeft;
    }
}

function getRowPinPosition(dataItem, topRows, bottomRows, idField) {
    if (!idField || !dataItem) {
        return "none";
    }
    const key = dataItem[idField];
    if (topRows.some(r => r[idField] === key)) {
        return "top";
    }
    if (bottomRows.some(r => r[idField] === key)) {
        return "bottom";
    }
    return "none";
}

function resolveInitialPinnedRows(pinnable, idField, dataSourceGet) {
    if (!pinnable || typeof pinnable !== "object" || (!pinnable.top && !pinnable.bottom)) {
        return null;
    }

    if (!idField) {
        return null;
    }

    const resolve = (ids) => {
        if (!Array.isArray(ids)) {
            return [];
        }
        return ids.map(id => dataSourceGet(id)).filter(item => !!item);
    };

    return {
        top: resolve(pinnable.top),
        bottom: resolve(pinnable.bottom)
    };
}

function markPinnedSourceRows(tbody, topRows, bottomRows, idField) {
    if (!tbody) {
        return;
    }

    const $tbody = $(tbody);
    $tbody.find("tr." + PINNED_SOURCE_CLASS).removeClass(PINNED_SOURCE_CLASS);

    if (!idField) {
        return;
    }

    const allPinned = [...topRows, ...bottomRows];

    allPinned.forEach(pinnedItem => {
        const uid = pinnedItem.uid;
        if (uid) {
            $tbody.find(`tr[data-uid="${uid}"]`).addClass(PINNED_SOURCE_CLASS);
        }
    });
}

function togglePinMenuItems(menuElement, position, pinRowLocation, messages) {
    const $menu = $(menuElement);
    const pinTop = $menu.find("[data-command=PinTopCommand]").closest(".k-menu-item");
    const pinBottom = $menu.find("[data-command=PinBottomCommand]").closest(".k-menu-item");
    const unpin = $menu.find("[data-command=UnpinCommand]").closest(".k-menu-item");

    if (pinRowLocation && pinRowLocation !== "both") {
        const parentItem = pinTop.closest(".k-menu-group").closest(".k-menu-item");

        pinTop.hide();
        pinBottom.hide();
        unpin.hide();

        if (parentItem.length) {
            parentItem.children(".k-menu-group, .k-animation-container").hide();
            parentItem.find("> .k-link .k-menu-expand-arrow, > .k-link > .k-menu-expand-arrow-icon").hide();

            const linkText = parentItem.find("> .k-link .k-menu-link-text");

            if (position !== "none") {
                parentItem.show();
                parentItem.attr(kendo.attr("command"), "UnpinCommand");
                parentItem.data("command", "UnpinCommand");
                if (linkText.length && messages) {
                    linkText.text(messages.unpin);
                }
            } else {
                parentItem.show();
                const cmd = pinRowLocation === "top" ? "PinTopCommand" : "PinBottomCommand";
                parentItem.attr(kendo.attr("command"), cmd);
                parentItem.data("command", cmd);
                if (linkText.length && messages) {
                    linkText.text(messages.pinRow);
                }
            }
        }
    } else {
        pinTop.toggle(position !== "top");
        pinBottom.toggle(position !== "bottom");
        unpin.toggle(position !== "none");
    }
}

function destroyPinnedContainer(wrapEl, containerEl) {
    if (wrapEl) {
        $(wrapEl).off("scroll");
    }
    if (containerEl) {
        $(containerEl).remove();
    }
}

function refreshPinnedReferences(topRows, bottomRows, dataSourceData, idField) {
    if (!idField) {
        return { top: topRows, bottom: bottomRows };
    }

    const findById = (id) => {
        for (let i = 0; i < dataSourceData.length; i++) {
            if (dataSourceData[i][idField] == id) {
                return dataSourceData[i];
            }
        }
        return null;
    };

    const refresh = (items) => items.map(item => {
        const fresh = findById(item[idField]);
        return fresh || null;
    }).filter(item => item !== null);

    return {
        top: refresh(topRows),
        bottom: refresh(bottomRows)
    };
}

function syncPinnedTableWidths(sourceTable, topTable, bottomTable) {
    if (!sourceTable) {
        return;
    }
    const width = sourceTable.style.width;
    if (width) {
        if (topTable) {
            topTable.style.width = width;
        }
        if (bottomTable) {
            bottomTable.style.width = width;
        }
    }
}

function syncPinnedLockedWidths(lockedWidth, contentWidth, topLocked, bottomLocked, topContent, bottomContent) {
    if (topLocked) {
        topLocked.style.width = lockedWidth;
    }
    if (bottomLocked) {
        bottomLocked.style.width = lockedWidth;
    }
    if (topContent) {
        topContent.style.width = contentWidth;
    }
    if (bottomContent) {
        bottomContent.style.width = contentWidth;
    }
}

function createPinnedLockedContent(sizeClass) {
    const container = document.createElement("div");
    container.className = "k-grid-content-locked";

    const table = document.createElement("table");
    table.className = "k-grid-table k-table" + (sizeClass ? " " + sizeClass : "");

    const colgroup = document.createElement("colgroup");
    const tbody = document.createElement("tbody");
    tbody.className = "k-table-tbody";

    table.appendChild(colgroup);
    table.appendChild(tbody);
    container.appendChild(table);

    return { container, table, tbody };
}

function flattenRowSpans(html) {
    if (html.indexOf("rowspan") === -1 && html.indexOf("rowSpan") === -1 && html.indexOf("hidden") === -1) {
        return html;
    }

    const temp = document.createElement("table");
    const tempBody = document.createElement("tbody");
    temp.appendChild(tempBody);
    tempBody.innerHTML = html;

    const rows = tempBody.querySelectorAll("tr");
    const rowCount = rows.length;

    for (let r = 0; r < rowCount; r++) {
        const cells = rows[r].querySelectorAll("td");
        for (let c = 0; c < cells.length; c++) {
            const cell = cells[c];

            if (cell.hasAttribute("rowspan")) {
                cell.removeAttribute("rowspan");
            }

            if (cell.hasAttribute("hidden")) {
                cell.removeAttribute("hidden");
                cell.style.display = "";
            }
        }
    }

    return tempBody.innerHTML;
}

function applyPinnedAria(containers, getByUid, idField) {
    containers.forEach((p) => {
        if (!p || !p.tbody) {
            return;
        }

        p.tbody.attr("role", "rowgroup");
        p.tbody.children("tr").each((_, el) => {
            const row = $(el);
            row.attr("role", "row");

            const uid = row.data("uid");
            if (uid) {
                const model = getByUid(uid);
                if (model && idField) {
                    row.attr("aria-label", "Pinned row");
                }
            }

            row.children("td").attr("role", "gridcell");
        });

        if (p.lockedTbody) {
            p.lockedTbody.attr("role", "rowgroup");
            p.lockedTbody.children("tr").each((_, el) => {
                const row = $(el);
                row.attr("role", "row");
                row.children("td").attr("role", "gridcell");
            });
        }
    });
}

export {
    PINNED_CONTAINER_CLASS,
    PINNED_WRAP_CLASS,
    PINNED_SOURCE_CLASS,
    createPinnedContainer,
    createPinnedLockedContent,
    syncPinnedColgroups,
    syncPinnedScroll,
    syncPinnedTableWidths,
    syncPinnedLockedWidths,
    refreshPinnedReferences,
    getRowPinPosition,
    resolveInitialPinnedRows,
    markPinnedSourceRows,
    togglePinMenuItems,
    destroyPinnedContainer,
    flattenRowSpans,
    applyPinnedAria
};
